module.exports = __webpack_public_path__ + "static/media/success.0db3126c.svg";